import React, { useCallback } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { PencilEdit02Icon, Search02Icon } from 'hugeicons-react';
import { useChatContext } from '../../contexts/AppDataContext';
import { useInputContext } from '../../contexts/InputContext';
import { useWindow } from '../../contexts/WindowContext';
import { useSpaceContext } from '../../contexts/AppDataContext';
import SpaceButton from '../Layout/Buttons/SpaceButton';
import { HoverToolTip } from '../Layout/Items/HoverToolTip';
import HistoryButton from './Buttons/HistoryButton';

interface ChatActionsProps {
  isMinimized?: boolean;
  onActionClick?: () => void;
}

const ChatActions: React.FC<ChatActionsProps> = ({ isMinimized = false, onActionClick }) => {
  const navigate = useNavigate();
  const { setIsSearchModalOpen, setMessages, setMemoizedChatTitle, isSpaceChat } = useChatContext();
  const { setInput, focusInput } = useInputContext();
  const { windowWidth } = useWindow();
  const { handleCreateSpaceChat } = useSpaceContext();

  const handleAddChat = useCallback(async () => {
    try {
      setMessages([]);
      setInput('');
      setMemoizedChatTitle('New Chat');
      navigate('/', { replace: false });
      if (windowWidth > 768) {
        setTimeout(() => {
          focusInput();
        }, 100);
      }
      onActionClick?.();
    } catch (error) {
      console.error('Failed to create a new chat:', error);
    }
  }, [navigate, setMessages, setInput, setMemoizedChatTitle, focusInput, windowWidth, onActionClick]);

  const handleSearchClick = () => {
    setIsSearchModalOpen(true);
    onActionClick?.();
  };

  const handleNewChatClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isSpaceChat) {
      handleCreateSpaceChat(true);
    } else {
      handleAddChat();
    }
  };


  if (isMinimized) {
    return (
      <>
        <NavLink 
          to="/"
          aria-label="Start new chat"
          onClick={handleNewChatClick}
        >
          <PencilEdit02Icon size={20} />
          <HoverToolTip
            text={isSpaceChat ? "New Space Chat" : "New Chat"}
            position="right"
          />
        </NavLink>
        <button onClick={handleSearchClick}>
          <Search02Icon size={20} />
          <HoverToolTip
            text="Search Messages"
            position="right"
          />
        </button>
        <HistoryButton />
        <SpaceButton onActionClick={onActionClick} />
      </>
    );
  }

  return (
    <div className="sidebar-header-bottom">
      <NavLink
        to="/"
        aria-label="Start new chat"
        onClick={handleNewChatClick}
      >
        <PencilEdit02Icon size={18} />
        <span>New Chat</span>
      </NavLink>
      <button onClick={handleSearchClick}>
        <Search02Icon size={18} />
        <span>Search</span>
      </button>
    </div>
  );
};

export default ChatActions;